<div class="modal-header d-flex">
    <div class="modal-title">Templates</div>
    <div type="button" class="gyan-popup-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <div class="modal-close-icon"></div>
    </div>
</div>
<div class="modal-body">
    <div class="template-popup font-14 accordion-div">
        <!-- <ng-scrollbar visibility="hover" [pointerEventsDisabled]="true"> -->
        <accordion [isAnimated]="true" [closeOthers]="false">
            <!-- Topic Outline -->
            <accordion-group
                *ngFor="let topic of topics; let i = index"
                heading="{{ topic.name }}"
                [isOpen]="i === 0"
                #accordionTemplate
                [ngClass]="{
                    accordionactive: accordionTemplate?.isOpen,
                    accordionNotactive: !accordionTemplate?.isOpen,
                }"
            >
                <span accordion-heading>
                    <fa-icon
                        class="float-end"
                        [ngClass]="accordionTemplate?.isOpen ? 'highlighted-text' : 'nohighlight-text'"
                        [icon]="accordionTemplate?.isOpen ? faAngleUp : faAngleDown"
                    ></fa-icon>
                </span>
                <div class="topic-outline-form">
                    <!-- outline form-->

                    <div *ngFor="let ontology of topic.ontologies">
                        <div *ngIf="isMobile" class="view-icon float-start" (click)="togglePopup($event, ontology)" [title]="ontologyTooltip(ontology)"></div>
                        <div
                            *ngIf="!isMobile"
                            class="view-icon float-start"
                            (mouseover)="togglePopup($event, ontology)"
                            (mouseout)="hidePopup()"
                            [title]="ontologyTooltip(ontology)"
                        ></div>
                        <div class="template-topic-name" (click)="applyTemplate(ontology)">{{ ontology.name }}</div>
                        <!-- Popup content shown on hover -->
                        <div *ngIf="selectedOntology === ontology && popupVisible" class="popup-content" (click)="$event.stopPropagation()">
                            <div *ngIf="ontology.childOntologys && ontology.childOntologys.length > 0">
                                <div *ngFor="let child of ontology.childOntologys" class="menu-dropdown-item">{{ child.name }}</div>
                            </div>
                            <div *ngIf="!ontology.childOntologys || ontology.childOntologys.length === 0">No subtopics available</div>
                        </div>
                        <div class="clear"></div>
                    </div>
                </div>
            </accordion-group>
        </accordion>
        <!-- </ng-scrollbar> -->
    </div>
</div>
